import type {
  DatePickerInputProps,
  DatesRangeValue,
  DateValue,
} from "@mantine/dates";
import {
  type Control,
  type FieldPath,
  type FieldValues,
  useController,
} from "react-hook-form";

import { DatePickerInput } from "@/components/ui/elements";

type Props<FORM_TYPE extends FieldValues> = {
  control: Control<FORM_TYPE>;
  name: FieldPath<FORM_TYPE>;
} & DatePickerInputProps;

export function DatePickerInputField<FORM_TYPE extends FieldValues>(
  props: Props<FORM_TYPE>,
) {
  const { control, name, ...inputProps } = props;
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  });
  const onChange = (date: DateValue | DatesRangeValue | Date[]) => {
    // 文字列の場合はDateオブジェクトに変換
    if (typeof date === "string") {
      const dateObject = new Date(date);
      return field.onChange(dateObject);
    }
    return field.onChange(date);
  };
  return (
    <DatePickerInput<"default">
      value={field.value}
      defaultValue={field.value}
      onChange={onChange}
      error={error?.message}
      {...inputProps}
    />
  );
}
